import React from 'react';

export const blockPropagation = (
  event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
): void => {
  const { nativeEvent } = event;
  nativeEvent?.stopImmediatePropagation();
  event.stopPropagation();
};
